import {
  FETCH_PRODUCT_GALLERY,
  FETCH_PRODUCT_GALLERY_FULFILLED,
  FETCH_PRODUCT_GALLERY_REJECTED,
} from 'b2b-apps/shop/product/redux/productGallery/actionTypes';
import {
  FetchProductGalleryAction,
  FetchProductGalleryFulfilledAction,
  FetchProductGalleryRejectedAction,
  ProductGalleryType,
} from 'b2b-apps/shop/product/redux/productGallery/types';

const fetchProductGallery = (sku: string): FetchProductGalleryAction => ({
  type: FETCH_PRODUCT_GALLERY,
  payload: {
    sku,
  },
});

const fetchProductGalleryFulfilled = (
  sku: string,
  response: ProductGalleryType,
): FetchProductGalleryFulfilledAction => ({
  type: FETCH_PRODUCT_GALLERY_FULFILLED,
  payload: {
    data: response,
    sku,
  },
});

const fetchProductGalleryRejected = (
  sku: string,
  error: ErrorType,
): FetchProductGalleryRejectedAction => ({
  type: FETCH_PRODUCT_GALLERY_REJECTED,
  payload: {
    error,
    sku,
  },
});

export {
  fetchProductGallery,
  fetchProductGalleryFulfilled,
  fetchProductGalleryRejected,
};
